module.exports = __webpack_public_path__ + "img/tweet_liked.85a4499b.svg";